import script from "./ReadingTest.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReadingTest.vue?vue&type=script&lang=ts&setup=true"

import "./ReadingTest.vue?vue&type=style&index=0&id=427b8493&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/jet/cbt/production/deploy-cbt/exam/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-427b8493"]])

export default __exports__